<h2 mat-dialog-title class="main-content">
  <span>Select</span>
  @if (!loading && lookupConfig.pageable) {
    <mat-paginator
      class="content-pagination"
      [length]="response.total"
      [pageSize]="response.perPage"
      [pageIndex]="response.offset"
      [pageSizeOptions]="[50, 100, 200]"
      [showFirstLastButtons]="true"
      (page)="pageChanged($event)">
    </mat-paginator>
  }
  <div>
    @if (data.fieldConfig.lookupInsertUrl) {
      <button type="button" mat-icon-button (click)="showAddForm = !showAddForm">
        @if (!showAddForm) {
          <i class="fas fa-plus" matTooltip="Add"></i>
        }
        @if (showAddForm) {
          <i class="fas fa-arrow-left" matTooltip="Return"></i>
        }
      </button>
    }
    @if (showAddForm) {
      <button type="button" mat-icon-button matTooltip="Add" (click)="tryToAdd()" [disabled]="!editFormGroup.valid">
        <i class="fas fa-plus"></i>
      </button>
    }
    @if (!showAddForm && data.returnAll) {
      <button type="button" mat-icon-button matTooltip="Add all visible" (click)="returnAll()">
        <i class="fas fa-check-double"></i>
      </button>
    }
  </div>
</h2>
@if (!showAddForm) {
  <mat-dialog-content>
    @if (loading) {
      <div>
        <mat-spinner [diameter]="24" class="spinner"></mat-spinner>
      </div>
    }
    @if (!loading && !lookupConfig.pageable) {
      <div>
        <mat-form-field>
          <textarea placeholder="Filter" matInput (keyup)="onFilterChange($event)"></textarea>
        </mat-form-field>
        @if (missingIds && missingIds.size > 0) {
          <div class="info-text">
            MISSING:
            @for (missingId of missingIds; track missingId) {
              <b>#{{ missingId }} </b>
            }
          </div>
        }
      </div>
    }
    @if (!loading) {
      @if (data.fieldConfig.lookup === 'image' || data.fieldConfig.lookup === 'hero_slide') {
        <cdk-virtual-scroll-viewport itemSize="80" class="example-viewport" class="scroll-content">
          <table>
            <tr>
              @for (field of allFields; track field) {
                <th class="info-label">{{ field.label }}</th>
              }
            </tr>
            <tr
              class="filtered-content"
              *cdkVirtualFor="let element of dataSource.filteredData"
              (click)="onRowClick(element, $event)">
              @for (field of allFields; track field) {
                <td [style.width]="field.name === 'name' ? '200px' : '0'" class="lookup-info">
                  <app-table-cell
                    [type]="field.type"
                    [data]="element[field.name]"
                    [fieldConfig]="field"></app-table-cell>
                </td>
              }
            </tr>
          </table>
        </cdk-virtual-scroll-viewport>
      }
      @if (data.fieldConfig.lookup !== 'image' && data.fieldConfig.lookup !== 'hero_slide') {
        <cdk-virtual-scroll-viewport itemSize="50" class="example-viewport">
          @if (data.fieldConfig.lookupLayout === 'list') {
            <table mat-table [dataSource]="dataSource" class="main-table">
              @for (field of allFields; track field) {
                <ng-container matColumnDef="{{ field.name }}">
                  <th mat-header-cell *matHeaderCellDef>{{ field.label }}</th>
                  <td mat-cell *matCellDef="let element">
                    <app-table-cell
                      [type]="field.type"
                      [data]="element[field.name]"
                      [fieldConfig]="field"></app-table-cell>
                  </td>
                </ng-container>
              }
              <tr mat-header-row *matHeaderRowDef="displayedFieldsNames"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: displayedFieldsNames; let i = index"
                (click)="onRowClick(row, $event)"
                class="maintain-row"
                [attr.data-id]="'listItem' + i"></tr>
            </table>
          } @else {
            <div class="grid-layout">
              @for (element of dataSource.filteredData; track element) {
                <div (click)="onRowClick(element, $event)">
                  @for (field of allFields; track field) {
                    <app-form-field
                      [type]="field.type"
                      [data]="element[field.name]"
                      [fieldConfig]="field"></app-form-field>
                  }
                </div>
              }
            </div>
          }
        </cdk-virtual-scroll-viewport>
      }
    }
  </mat-dialog-content>
}

@if (showAddForm) {
  <mat-dialog-content>
    <app-entity-group-subset [config]="editFormConfig" [formGroup]="editFormGroup" [data]="{}">
    </app-entity-group-subset>
  </mat-dialog-content>
}
